import clsx from 'clsx'
import { FC } from 'react'

import StepTable from 'components/parts/step-table/step-table'

import { educationSteps } from './data'

import styles from './how-education-works.module.scss'

interface IHowEducationWorks {
  modificator?: string
}

const HowEducationWorks: FC<IHowEducationWorks> = ({ modificator }) => {
  return (
    <section
      className={clsx(styles.education, {
        [modificator as string]: modificator,
      })}
    >
      <p className={styles.educationTitle}>Как проходит обучение?</p>
      <StepTable stepsData={educationSteps} />
    </section>
  )
}

export default HowEducationWorks
